import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { PROFESSOR_STORE, ProfessorStore, JustificativaValidator, ValidationError } from '../../Store';
import { RouteComponentProps } from 'react-router';
import { InformacoesAgendamento } from './Components/InformacoesAgendamento';
import { JustificativaDoConviteModal } from './Components/JustificativaDoConviteModal';
import { withStateCard, Container, ToastType, Toast, TutorialButtonAndBackButton } from '../../Components';
import styled from 'styled-components';
import { DetalhesBanca } from './Components/DetalhesBanca';
import { AUTH_STORE, AuthStore } from '../../Store/Auth';
import Tutorial_Professor from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Professor.pdf";
import PageSubTitle from "../../Components/PageSubTitle";

/*
  interfaces
*/ interface IProps extends RouteComponentProps<{ id: string }> {
  [PROFESSOR_STORE]: ProfessorStore;
  [AUTH_STORE]: AuthStore;

}

interface IState {
  modalIsOpen: boolean;
  justificativa: string;
  validation?: ValidationError<{ justificativa: string }>;
}
/*
  styled components
*/
const ContainerWithState = styled(withStateCard(Container))`
  display: grid;
  justify-content: normal;
`;

/*
  component: ResumoConvite
*/
@inject(PROFESSOR_STORE, AUTH_STORE)
@observer
export default class ResumoConvite extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      modalIsOpen: false,
      justificativa: '',
    };
  }

  componentDidMount() {
    const professorStore = this.props[PROFESSOR_STORE];
    professorStore.recuperarInformacoesConvite(
      parseInt(this.props.match.params.id)
    );
  }

  aceitarConvite = async () => {
    const store = this.props[PROFESSOR_STORE];

    await store.responderConvite(parseInt(this.props.match.params.id), true);
    this.props.history.push('/professor');
  };

  rejeitarConvite = async () => {
    const store = this.props[PROFESSOR_STORE];

    const error = JustificativaValidator.getErrors({ justificativa: this.state.justificativa });
    this.setState({ validation: error });

    if (!error) {
      await store.responderConvite(parseInt(this.props.match.params.id), false, this.state.justificativa);
      this.props.history.push('/professor');
    }
  }

  onResumeClick = () => {
    window.open(Tutorial_Professor);
  }

  render() {
    const { [PROFESSOR_STORE]: professorStore } = { ...this.props };
    const { [AUTH_STORE]: authStore } = { ...this.props };

    const { convite, professoresState, conviteRespondido } = professorStore;
    const { currentUser } = authStore;

    const { history } = this.props;

    return (
      <>
        <PageSubTitle subTitle={'Resumo do Convite'} />
        <TutorialButtonAndBackButton
          openTutorial={this.onResumeClick}
          voltar={() => history.push('/professor')}
        />
        <ContainerWithState state={professoresState}>
          {conviteRespondido &&
            <Toast type={ToastType.success}>Convite respondido</Toast>}
          <InformacoesAgendamento
            monografia={convite}
            currentUser={currentUser}
            aceitarConvite={this.aceitarConvite}
            rejeitarConvite={() => this.setState({ modalIsOpen: true })}
          />
          <DetalhesBanca monografia={convite} />
          <JustificativaDoConviteModal
            isOpen={this.state.modalIsOpen}
            outterClick={() => this.setState({ modalIsOpen: false })}
            onTextChange={e => this.setState({ justificativa: e.target.value })}
            texto={this.state.justificativa}
            rejeitar={this.rejeitarConvite}
            errors={this.state.validation}
          />
        </ContainerWithState>
      </>
    );
  }
}
